<template>
  <responsive-modal v-model="showing">
    <div
      class="confirmation"
      :class="{
        'confirmation-new': newDesign
      }"
    >
      <div v-if="newDesign" class="bg-waves" :class="type">
        <svg
          width="calc(100% + 32px)"
          viewBox="0 0 500 122"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.25">
            <path
              d="M259.018 106.382C133.166 85.4489 33.9011 97.66 0 106.382V6.88235C0 1.72059 4.5 0 8 0H492C498 0 500 4.30147 500 6.88235V102.522C472.111 112.531 384.87 127.316 259.018 106.382Z"
              :fill="fill"
              fill-opacity="0.85"
            />
            <path
              d="M259.1 105.889C133.949 85.0722 35.0545 97.0101 0.5 105.739V6.88235C0.5 4.4727 1.53844 2.90331 2.97097 1.91739C4.42725 0.915127 6.31944 0.5 8 0.5H492C494.868 0.5 496.729 1.52244 497.877 2.80662C499.039 4.10614 499.5 5.70545 499.5 6.88235V102.169C471.355 112.14 384.396 126.73 259.1 105.889Z"
              :stroke="fill"
              stroke-opacity="0.85"
              stroke-linejoin="round"
            />
          </g>
          <g opacity="0.2">
            <path
              d="M126 112.906C366.378 45.4952 466.099 103.649 500 112.906V7.30442C500 1.82611 495.5 0 492 0H8C2 0 3.05176e-05 4.56526 0 7.30442V108.809C0 108.809 49 134.5 126 112.906Z"
              :fill="fill"
              fill-opacity="0.85"
            />
            <path
              d="M125.865 112.425C246.109 78.7039 331.201 76.3811 390.49 83.6594C435.131 89.1396 465.18 100.078 484.488 107.107C490.492 109.293 495.457 111.1 499.5 112.248V7.30442C499.5 4.7238 498.45 3.04815 497.018 2.0016C495.563 0.938912 493.675 0.5 492 0.5H8C5.14221 0.5 3.28406 1.58018 2.13239 2.94718C0.965973 4.33168 0.5 6.04034 0.5 7.30442V108.502C0.578552 108.541 0.674286 108.588 0.787018 108.642C1.15976 108.823 1.7186 109.086 2.4584 109.414C3.93805 110.069 6.14142 110.984 9.02759 112.015C14.8 114.077 23.303 116.606 34.2089 118.462C56.0191 122.175 87.4437 123.2 125.865 112.425Z"
              :stroke="fill"
              stroke-opacity="0.85"
              stroke-linejoin="round"
            />
          </g>
        </svg>
        <div
          class="d-flex justify-content-center align-items-center big-icon"
          :class="type"
        >
          <i :class="icon" />
        </div>
      </div>

      <div :class="{ 'p-6 m-3 new-content': newDesign }">
        <div
          v-if="!newDesign"
          class="d-flex justify-content-center align-items-center"
        >
          <div v-if="isLogout" class="icon-logout">
            <i class="ph ph-sign-out" />
          </div>
          <modal-icon v-else icon="exclamation-solid" />
        </div>

        <h4 class="text-center px-6 pt-3" v-if="title.length && !newDesign">
          {{ title }}
        </h4>
        <div
          v-if="!custom"
          class="text-center text-dark pt-4 mb-6 text"
          :class="{ 'px-3': bigText, 'px-6': !bigText, 'new-text': newDesign }"
        >
          {{ text }}
        </div>
        <div v-else>
          <slot />
        </div>
        <div class="row justify-content-center mt-9" v-if="!customButtons">
          <div
            class="col-lg-6 mb-lg-0 mb-2"
            :class="{ 'pr-3': newDesign }"
            v-if="showCancelButton"
          >
            <snow-button
              size="lg"
              class="w-100"
              variant="gray"
              :class="[cancelButtonClass, { 'btn-new-secondary': newDesign }]"
              @click="cancel"
            >
              {{ cancelButtonText }}
            </snow-button>
          </div>
          <div class="col-lg-6" :class="{ 'pl-3': newDesign }">
            <snow-button
              size="lg"
              class="w-100"
              :class="confirmButtonClass"
              @click="confirm"
            >
              {{ confirmButtonText }}
            </snow-button>
          </div>
        </div>
      </div>
    </div>
  </responsive-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    iconType: {
      type: String,
      default: "checked"
    },
    text: {
      type: String,
      default: "Tem certeza?"
    },
    title: {
      type: String,
      default: ""
    },
    cancelButtonText: {
      type: String,
      default: "Cancelar"
    },
    confirmButtonText: {
      type: String,
      default: "Confirmar"
    },
    cancelButtonClass: {
      type: String,
      default: "btn-outline-secondary"
    },
    confirmButtonClass: {
      type: String,
      default: "btn-primary"
    },
    bigText: {
      type: Boolean,
      default: () => false
    },
    custom: {
      type: Boolean,
      default: () => false
    },
    newDesign: {
      type: Boolean,
      default: false
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    customButtons: {
      type: Boolean,
      default: false
    },
    isLogout: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showing: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    type() {
      return this.confirmButtonClass.substring(4);
    },
    fill() {
      let colors = {
        danger: "#FFD4D7",
        primary: "#E6D5FF",
        success: "#52FF86D9"
      };
      return colors[this.type];
    },
    icon() {
      let icons = {
        danger: "fa fa-xmark",
        primary: "fa fa-exclamation",
        success: "fa fa-check"
      };
      return icons[this.type] || "fa fa-exclamation";
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
      this.showing = false;
    },
    confirm() {
      this.$emit("confirm");
      this.showing = false;
    }
  }
};
</script>

<style lang="scss">
.confirmation {
  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
  }

  .text {
    font-size: 18px;
    line-height: 17px;
  }

  button {
    font-size: 12px;
  }
}

.confirmation-new {
  button {
    font-size: 14px !important;
  }
}

.bg-waves {
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  position: relative;
  height: 122px;
  @media screen and (max-width: 991px) {
    height: 180px;
    top: -20px;
  }

  svg {
    top: -8px;
    left: -16px;
    position: absolute;
    height: 100%;
  }
}

.big-icon {
  position: relative;
  top: 35px;
  border-radius: 50%;
  width: 60px;
  aspect-ratio: 1;
  margin: 0 auto;
  background-color: white;
  font-size: 32px;
  box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.16);
  @media screen and (max-width: 991px) {
    top: 60px;
  }
  &.danger {
    color: #d0000e;
    border: 2px solid #ff2635;
  }
  &.primary {
    color: #781effe0;
    border: 2px solid #9955ffdd;
  }
  &.success {
    border: 2px solid #008f2bdd;
    color: #006b20e0;
  }

  i {
    padding: 8px 12px;
  }
}

.new-text {
  font-size: 14px;
  color: #3b3b4a !important;
  padding: 0 38px !important;
}

.icon-logout {
  font-size: 80px;
  font-weight: 400;
}
</style>
